export enum PriceTypes {
  PER_UNIT,
  PER_AREA,
}
